/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Error',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M12 6.16406C12.3314 6.16406 12.6 6.43269 12.6 6.76406V13.7743C12.6 14.1057 12.3314 14.3743 12 14.3743C11.6686 14.3743 11.4 14.1057 11.4 13.7743L11.4 6.76406C11.4 6.43269 11.6686 6.16406 12 6.16406Z"
            fill="currentColor"
          />
          <path
            d="M12.8 17.0372C12.8 17.479 12.4418 17.8372 12 17.8372C11.5582 17.8372 11.2 17.479 11.2 17.0372C11.2 16.5954 11.5582 16.2372 12 16.2372C12.4418 16.2372 12.8 16.5954 12.8 17.0372Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21.8 12C21.8 17.4124 17.4124 21.8 12 21.8C6.58761 21.8 2.2 17.4124 2.2 12C2.2 6.58761 6.58761 2.2 12 2.2C17.4124 2.2 21.8 6.58761 21.8 12Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
